const multilingual = (value, languageId) => {
  if (!value || !languageId || !value[languageId]) {
    return '-';
  }

  return value[languageId];
};

export default multilingual;
